import { useState } from "react";
import Card from "../UI/Card";
import ModalDialog from "../UI/ModalDialog";
// @ts-expect-error pure js
import { DocType } from "../../utils/constants/documents";
// @ts-expect-error pure js
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
// @ts-expect-error pure js
import Img from "../UI/Img";
import SignaturePad from "../UI/SignaturePad";
import styles from "./Signature.module.css";
// @ts-expect-error pure js
import useDocumentBlob from "../../hooks/use-document-blob.js";
// @ts-expect-error pure js
import useLoader from "../../hooks/use-loader.js";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
import Button from "../UI/Button";
import Text from "../UI/Text";
import Title from "../UI/Title";
import type { DocumentFile } from "../../models/document";
import { IconWritingSign } from "@tabler/icons-react";
import ButtonCard from "../UI/ButtonCard.tsx";
// @ts-expect-error pure js
import IconAndText from "../UI/IconAndText";

interface SignatureProps {
  customization?: { signature_file?: DocumentFile | null } | null;
  onSave: (data: { signature_file: DocumentFile }) => Promise<unknown>;
  onReset: (fieldsToReset: string[]) => Promise<unknown>;
  isProfile?: boolean;
}

export default function Signature({
  customization,
  onSave,
  onReset,
  isProfile,
}: SignatureProps) {
  const [signatureModalOpen, setSignatureModalOpen] = useState(false);
  const axios = useAuthenticatedAxios();

  const { blob: signatureBlob } = useDocumentBlob({
    documentId: customization?.signature_file?.id,
    doctype: DocType.SIGNATURE,
  });

  async function saveSignatureHandler(blob: Blob, filename: string) {
    const formData = new FormData();
    formData.append("documents", blob, filename);
    try {
      const res = await axios.post<DocumentFile[]>(
        "/documents/upload",
        formData,
        {
          params: { doctype: DocType.SIGNATURE },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      await onSave({ signature_file: res.data[0] });
      setSignatureModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  }

  const [resetting, resetHandler] = useLoader(async () => {
    try {
      await onReset(["signature_file"]);
    } catch (e) {
      handleAPIError(e);
    }
  });

  const deleteButtonText = isProfile
    ? "Utiliser la signature du compte"
    : "Supprimer la signature";

  return (
    <>
      <ModalDialog
        size="sm"
        open={signatureModalOpen}
        onOpenChange={setSignatureModalOpen}
        header="Ajouter une signature"
      >
        <SignaturePad onSave={saveSignatureHandler} />
      </ModalDialog>
      <Card className={styles.card}>
        <Title variant="hecto" weight="medium">
          Signature des documents
        </Title>
        <ButtonCard
          onClick={() => setSignatureModalOpen(true)}
          requiresWrite
          className={styles.buttonAdd}
        >
          <IconAndText
            icon={<IconWritingSign />}
            text={
              <>
                <Text weight="bold">Ajouter une signature</Text>
                <Text variant="deci" color="muted">
                  Dessiner ou importer une photo
                </Text>
              </>
            }
          />
        </ButtonCard>
        {signatureBlob ? (
          <Img blob={signatureBlob} alt="signature" cover />
        ) : (
          <Card padding="sm" className={styles.empty}>
            Pas de signature enregistrée
          </Card>
        )}
        <Button
          variant="tertiary"
          onClick={resetHandler}
          isLoading={resetting}
          requiresWrite
          className={styles.action}
        >
          {deleteButtonText}
        </Button>
      </Card>
    </>
  );
}
